import { render, staticRenderFns } from "./OTEnProgresoSemanal.vue?vue&type=template&id=5036abf9&scoped=true&"
import script from "./OTEnProgresoSemanal.vue?vue&type=script&lang=js&"
export * from "./OTEnProgresoSemanal.vue?vue&type=script&lang=js&"
import style0 from "./OTEnProgresoSemanal.vue?vue&type=style&index=0&id=5036abf9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5036abf9",
  null
  
)

export default component.exports